import { Directive, Input } from '@angular/core';
import { ValidationErrors, AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[sdCustomValidator]',
  providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: SdCustomValidator, multi: true }]
})
export class SdCustomValidator implements AsyncValidator {
  @Input('sdCustomValidator') func: (value: any) => string | Promise<string>;
  async validate(c: AbstractControl): Promise<ValidationErrors> {
    const value = c.value || null;
    if (this.func && typeof (this.func) === 'function') {
      const result = this.func(value);
      if (result instanceof Promise) {
        const message = await result;
        if (message) {
          return {
            customValidator: message
          };
        }
        return null;
      }
      if (result) {
        return {
          customValidator: result
        };
      }
      return null;
    }
    return null;
  }
}
